import { useEffect, useState } from "react";

export const useFormattedTime = (date: Date) => {
  const [resultString, setResultString] = useState<string>("");

  useEffect(() => {
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");

    const timezoneOffset = -date.getTimezoneOffset();
    const sign = timezoneOffset >= 0 ? "+" : "-";
    const timezoneHours = Math.floor(Math.abs(timezoneOffset) / 60)
      .toString()
      .padStart(2, "0");
    const timezoneMinutes = (Math.abs(timezoneOffset) % 60)
      .toString()
      .padStart(2, "0");

    const timezoneString = `GMT${sign}${timezoneHours}:${timezoneMinutes}`;

    setResultString(`${hours}:${minutes} ${timezoneString}`);
  }, [date]);

  return resultString;
};
